import { B2bComponent } from '../b2b.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class MyOrdersComponent implements OnInit {

  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

      // Debounce search.
      this.searchUserUploaderUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetUserUploadersFiltered(value);
        });

          // Debounce search.
     this.searchUserManagerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetUserManagersFiltered(value);
      });

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, null, true);
      });
  
     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.GetInvoicesFiltered(this.Filter.Pager.PageIndex = 1);
        }
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  searchPartnerUpdate = new Subject<string>();
  searchUserManagerUpdate = new Subject<string>();
  searchUserUploaderUpdate = new Subject<string>();

  ngOnInit(): void {
    this.InitializeFilter();
    this.parent.InitializeCart();
    this.GetInvoiceMasterData();
  }

  Filter: {[k: string]: any} = {};
  MasterData: {[k: string]: any} = {};
  CurrentShippingAddress:any;
  activeFilters:{[k: string]: any} = [];
  Orders:{[k: string]: any} = [];
  Totals:{[k: string]: any} = [];
  searchTerm:string;
  Partners:any[];
  resultsLength:number = 0;
  partner:any;
  CurrentOrder:any;
  Invoices:any[];
  ReadyItems:any[];

  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DocumentStatuses:any[];
  Periods:any[];
  Languages:any[];
  PaymentTerms:any[];
  DiscountTypes:any[];
  Agents:any[];
  Countries:any[];
  CashCollectTypes:any[];
  CashCollections:any[];
  ShowSuggestionCashCollectionsContainer:boolean;
  CashTotals:any[];
  SortingOrders:any[];
  CountryFilterOptions:any[];
  PartnerTypes:any[];
  TranzactionTypes:any[];
  InvoiceModels:any[];
  currentCashCollettion: {[k: string]: any} = {};
  currency:any;
  BankAccounts:any[];
  InvoicePrecision:any;

  ShippingResponsabilities:any[];
  ShippingResponsability:any;
  ShippingServiceTypes:any[];
  ShippingServiceType:any;

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  loadingOrders:boolean;
  showFilter:boolean;
  ShowExportBulkQuestion:boolean;
  AllSelected:boolean;
  ShowOrderCancelation:boolean;
  ShowOrderCopy:boolean;
  ShowEditContainer:boolean;

  SearchUserManager:string;
  UserManagers:any[];
  UserManagersLength:number = 0;
  UserManager:any;

  SearchUserUploader:string;
  UserUploaders:any[];
  UserUploadersLength:number = 0;
  UserUploader:any;

  ShowOrderBillingInformation:boolean = true;
  ShowOrderShippingInformation:boolean = true;
  ShowOrderGeneralInformation:boolean = true;
  ShowOrderProductsInformation:boolean = false;
  ShowOrderDetailsPage:boolean = false;
  ShowOrders:boolean = true;

  ShowOrdersClick(){
    this.ShowOrders = true;
  }

  ShowReadyItems(){
    this.ShowOrders = false;
    this.GetB2BClientOCReadyItemsUX();
  }

  ReadyItemsTotal:any;
  ReadyItemsTotalCurrency:string;

  GetB2BClientOCReadyItemsUX(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:this.parent.B2BPartner,
    };
  
    this.parent.loading = true;
  
    this.B2BService.GetB2BClientOCReadyItemsUX(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ReadyItems = response["Items"];
        this.ReadyItemsTotal = response["ReadyItemsTotal"];
        this.ReadyItemsTotalCurrency = response["ReadyItemsTotalCurrency"];
        this.ShippingResponsabilities = response["ShippingResponsabilities"];
        this.ShippingServiceTypes = response["ShippingServiceTypes"];

        this.GetPartnerShippingAddresses(this.parent.B2BPartner?.ID);
        this.GetPartnerAgents(this.parent.B2BPartner?.ID);
      }
  
      this.parent.loading = false;
     });
  }

  GetInvoicesFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    if(this.Filter.DisplayAllPagesTotals == true){
      this.Filter.ExchangeToTargetCurrency = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }
    
    this.parent.loading = true;
    this.showFilter = false;

    this.B2BService.GetB2BInvoices(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Invoices = response["Invoices"];
        this.Totals = response["Totals"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
      
      this.AllSelected = false;
      this.parent.loading = false;
    });

    this.GetInvoicesFilteredCOUNT();
  }

  GetInvoicesFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.B2BService.GetInvoicesFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
    });
  }

  GetInvoiceMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoiceMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];
        this.Languages = response["Languages"];
        this.PaymentTerms = response["PaymentTerms"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DiscountTypes = response["DiscountTypes"];
        this.Agents = response["Agents"];
        this.DocTypes = response["DocTypes"];
        this.Periods = response["Periods"];
        this.DocumentStatuses = response["DocumentStatuses"];
        this.Countries = response["Countries"];
        this.CashCollectTypes = response["CashCollectTypes"];
        this.currentCashCollettion.Type = this.CashCollectTypes[1];
        this.BankAccounts = response["BankAccounts"];
        this.SortingOrders = response["SortingOrders"];
        this.CountryFilterOptions = response["CountryFilterOptions"];
        this.PartnerTypes = response["PartnerTypes"];
        this.TranzactionTypes = response["TranzactionTypes"];
        this.InvoiceModels = response["InvoiceModels"];

        this.currency = this.Currencies[0];
        this.InvoicePrecision = this.DecimalPrecisions[0];
        this.Filter.SortingOrder = this.SortingOrders[0];
        this.Filter.Partner = this.parent.B2BPartner;

        this.GetB2BClientOrders();
      }
      
      this.parent.loading = false;
    });
  }

  

InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Administration = {};
    this.Filter.AccountingSeries = {};
    this.Filter.Product = "";
    this.Filter.Partner = {};
    this.Filter.DocumentNumber = "";
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;
    this.Filter.Country = {};
    this.Filter.Country = null;
    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.SortingOrder = {};
    this.Filter.SortingOrder = null;

    this.Filter.InvoiceDocType = {};
    this.Filter.InvoiceDocType = null;

    this.Filter.CountryFilterOption = {};
    this.Filter.CountryFilterOption = null;

    this.Filter.PartnerType = {};
    this.Filter.PartnerType = null;

    this.Filter.TranzactionType = {};
    this.Filter.TranzactionType = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;
    this.Filter.ExchangeToTargetCurrency = false;
}

ClearPeriod(){
  this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  this.Filter.Period = null;
}

DisablePeriod(){
  this.Filter.Period = null;
  this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
}

GetOfferRequestMasterData(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.parent.loading = true;

  this.B2BService.GetOfferRequestMasterData(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.MasterData = response;
      this.GetOrdersFiltered(1);
    }

    this.parent.loading = false;
   });
}

GetOrdersFiltered(page = 1){

  this.Filter.Pager.PageIndex = page;

  if(this.Filter.DisplayAllPagesTotals == true){
    this.Filter.ExchangeToTargetCurrency = false;
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
  }
  
  this.loadingOrders = true;
  this.showFilter = false;

  this.B2BService.GetOfferRequestsFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders = response["OfferRequests"];
      this.Totals = response["Totals"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
    
    this.loadingOrders = false;
  });

  this.GetOrdersFilteredCOUNT();
}

GetOrdersFilteredCOUNT(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
  }

  this.B2BService.GetOfferRequestsFilteredCOUNT(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Filter.Pager = response["Pager"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
 
  });
}

AddActiveFilter(filterName:string, filterType:string){
  var filter = {
    ID:this.parent.newGuid(),
    Name:filterName,
    Type:filterType
  };
  
  if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
    this.showFilter = false;
  }

  this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
  this.activeFilters.push(filter);

  if(filterType == "Period"){
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;

    this.FromDate = new FormControl(moment(this.Filter.FromDate));
    this.ToDate = new FormControl(moment(this.Filter.ToDate));
  }

  this.GetB2BClientOrders();
}

RemoveActiveFilter(ID:string, filterType:string){
  this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

  if(filterType == "Administration"){
    this.Filter.Administration = null;
  }
  else if(filterType == "Series"){
    this.Filter.AccountingSeries = null;
  }
  else if(filterType == "DocStatus"){
    this.Filter.DocumentStatus = null;
  }
  else if(filterType == "DocumentNumber"){
    this.Filter.DocumentNumber = null;
  }
  else if(filterType == "Product"){
    this.Filter.Product = null;
  }
  else if(filterType == "Partner"){
    this.Filter.Partner = null;
  }
  else if(filterType == "Period"){
    this.Filter.Period = null;
  }
  else if(filterType == "Country"){
    this.Filter.Country = null;
  }
  else if(filterType == "Currency"){
    this.Filter.Currency = null;
  }
  else if(filterType == "InvoiceDocType"){
    this.Filter.InvoiceDocType = null;
  }

  this.GetB2BClientOrders();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.Orders.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SelectAll(){
  this.Orders.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
  var request = {
    SearchTerm:searchTerm,
    CountryID:CountryID,
    PageIndex:1,
    PageSize:10,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company
  };

  if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.resultsLength = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.Partners = [];
    this.resultsLength = 0;
  }
}

GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
  var request = {
    SearchTerm:searchTerm,
    CountryID:CountryID,
    PageIndex:1,
    PageSize:50,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company
  };

  if(this.searchTerm.length >= 3){
    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.resultsLength = response["Count"];

       if(this.Partners.length == 1){
        this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
        this.GetInvoicesFiltered(1);
       }
      }
   
      this.parent.loading = false;
    });
  }
}

InitializeUserManagersOnClick(searchTerm:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:searchTerm,
  };

  if((searchTerm.length >= 3) && (this.UserManagers == null || this.UserManagers.length == 0)){
    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserManagers = response["Users"];
        this.UserManagersLength = this.UserManagers.length;
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.UserManagers = [];
    this.UserManagersLength = 0;
  }
}

GetUserManagersFiltered(s:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:s,
  };

  this.parent.loading = true;

  this.service.GetUsersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
      this.UserManagers = response["Users"];
      this.UserManagersLength = this.UserManagers.length;
    }
 
    this.parent.loading = false;
  });

}

InitializeUserUploadersOnClick(searchTerm:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:searchTerm,
  };

  if((searchTerm.length >= 3) && (this.UserUploaders == null || this.UserUploaders.length == 0)){
    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserUploaders = response["Users"];
        this.UserUploadersLength = this.UserUploaders.length;
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.UserUploaders = [];
    this.UserUploadersLength = 0;
  }
}

GetUserUploadersFiltered(s:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:s,
  };

  this.parent.loading = true;

  this.service.GetUsersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
      this.UserUploaders = response["Users"];
      this.UserUploadersLength = this.UserUploaders.length;
    }
 
    this.parent.loading = false;
  });

}

OpenOrderCancelation(o:any){
  this.CurrentOrder = JSON.parse(JSON.stringify(o));
  this.ShowOrderCancelation = true;
}

CancelOrder(o:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:o.DBID,
  };

  this.parent.loading = true;

  this.B2BService.CancelOfferRequest(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders.forEach(order => {
        if(order.DBID == o.DBID){
          order.ProcessingStatus = response["ProcessingStatus"];
          order.OfferRequestStatus = response["OfferRequestStatus"];
        }
      });
    }
 
    this.parent.loading = false;
  });
}

OpenCopyOrder(o:any){
  this.CurrentOrder = JSON.parse(JSON.stringify(o));
  this.ShowOrderCopy = true;
}

CopyOrder(o:any){
  this.GetOfferRequest(o.ID);
}

GetOfferRequest(RequestOfferID:string){
  var request = {
  User:this.parent.User,
  Language:this.parent.getLanguage(),
  RequestOfferID:RequestOfferID,
  GetCartItems:true,
  WithLogs:true,
};

this.parent.loading = true;

this.B2BService.GetOfferRequest(request).subscribe(response => {

  if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.CurrentOrder = response["OfferRequest"];
    this.ShowEditContainer = true;
  }

  this.parent.loading = false;
});

}

PrintOrder(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
  };

  this.parent.loading = true;

  this.B2BService.ExportOfferRequest(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.printPage(Document.Name , Document.PDFStream, Document.ID);
    }

    this.parent.loading = false;
  });
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ExportOrder(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
  };

  this.parent.loading = true;

  this.B2BService.ExportOfferRequest(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.parent.loading = false;
  });
}


printPage(name:string, html:string, ID:string) {
  var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
  + ' type="application/pdf"'
  + ' src="data:application/pdf;base64,'
  + escape(html)
  + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.CurrentOrder.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });
}

GetInvoiceByAccountingDisplayValue(i:any, print:boolean = true){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    AccountingDisplayValue:i.AccountingNumber.DisplayValue,
    UseInvoiceLanguage:true,
    ExportPDF:true,
  };

  this.parent.loading = true;

  this.service.GetInvoiceByAccountingDisplayValue(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Document = response["Document"];

      if(print == true){
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }
      else{
        this.download(Document.Name, Document.PDFStream);
      }
    }

    this.parent.loading = false;
  });
}

PrintInvoice(i:any){

  var user = JSON.parse(JSON.stringify(this.parent.User));

  user.Rights.AssignedCompanies.forEach(element => {
    element.IsSelected = false;
  });

  if(user.Rights.AssignedCompanies.some(x => x.ID == this.Filter.Company.ID)){
    user.Rights.AssignedCompanies.filter(x => x.ID == this.Filter.Company.ID)[0].IsSelected = true;
  }
  else{
    user.Rights.AssignedCompanies.push(JSON.parse(JSON.stringify(this.Filter.Company)));
    user.Rights.AssignedCompanies.filter(x => x.ID == this.Filter.Company.ID)[0].IsSelected = true;
  }

  var request = {
    User:user,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.parent.loading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.printPage(Document.Name , Document.PDFStream, Document.ID);
    }

    this.parent.loading = false;
  });
}

ExportInvoice(i:any){

  var user = JSON.parse(JSON.stringify(this.parent.User));

  user.Rights.AssignedCompanies.forEach(element => {
    element.IsSelected = false;
  });

  if(user.Rights.AssignedCompanies.some(x => x.ID == this.Filter.Company.ID)){
    user.Rights.AssignedCompanies.filter(x => x.ID == this.Filter.Company.ID)[0].IsSelected = true;
  }
  else{
    user.Rights.AssignedCompanies.push(JSON.parse(JSON.stringify(this.Filter.Company)));
    user.Rights.AssignedCompanies.filter(x => x.ID == this.Filter.Company.ID)[0].IsSelected = true;
  }

  var request = {
    User:user,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.parent.loading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.parent.loading = false;
  });
}

Companies:any[];

GetB2BPartnerRelatedCompanies(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    B2BPartner:this.parent.B2BPartner,
  };

  this.parent.loading = true;

  this.B2BService.GetB2BPartnerRelatedCompanies(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Companies = JSON.parse(JSON.stringify(response["Companies"]));
      this.Filter.Company = this.Companies[0];
      this.GetInvoicesFiltered();
    }

    this.parent.loading = false;
  });
}

GetB2BClientOrders(page = 1){

  if(this.Filter?.Pager != null){
    this.Filter.Pager.PageIndex = page;
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingOrders = true;

  this.B2BService.GetB2BClientOrders(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders = JSON.parse(JSON.stringify(response["Orders"]));
      this.Filter.Pager = JSON.parse(JSON.stringify(response["Pager"]));
    }

    this.loadingOrders = false;
  });
}

Order:any;
ShowOrderDetailsMenu:boolean = false;
ShowOrderDocumentsMenu:boolean = false;

SelectOrderDetailsMenu(){
  this.ShowOrderDetailsMenu = true;
  this.ShowOrderDocumentsMenu = false;
}

SelectOrderDocumentsMenu(){
  this.ShowOrderDetailsMenu = false;
  this.ShowOrderDocumentsMenu = true;
}

GetClientOCDetails(o:any){

  o.IsLoading = true;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    OrderID:o.ID,
    Order:o,
  };

  this.B2BService.GetClientOCDetails(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Order = JSON.parse(JSON.stringify(response["Order"]));
      this.ShowOrderDetailsPage = true;
      this.ShowOrderDetailsMenu = true;
    }

    o.IsLoading = false;
  });
}

BackToOrders(){
  this.ShowOrderDetailsPage = false;
  this.ShowOrderDetailsMenu = true;
}

ShippingMasterData: {[k: string]: any} = {};
GeneralShippingServiceTypes:any[];
ShippingWays:any[];
ShippingCompanies:any[];
WeightTypes:any[];
Directions:any[];
ShowDeleteBoxQuestion:boolean;
CurrentBox:any;
ShippingDetails: {[k: string]: any} = {};

GetPartnerShippingAddresses(PartnerID:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:PartnerID
  };

  this.parent.loading = true;
  this.service.GetPartnerShippingAddresses(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.B2BPartner.ShippingAddresses = response["ShippingAddresses"];
      this.CurrentShippingAddress = this.parent.B2BPartner.ShippingAddresses[0];
      this.GetShippingMasterData();
    }
 
    this.parent.loading = false;
  });
}

PartnerAgents:any[];

GetPartnerAgents(PartnerID:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PartnerID:PartnerID
  };

  this.parent.loading = true;
  this.service.GetPartnerAgents(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.PartnerAgents = response["PartnerAgents"];
    }
 
    this.parent.loading = false;
  });
}

GetShippingMasterData(){
  var request = {
   User:this.parent.User,
   Language:this.parent.getLanguage()
 };

this.parent.loading = true;

this.managementService.GetShippingMasterData(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
   this.ShippingMasterData = JSON.parse(JSON.stringify(response));
   this.GeneralShippingServiceTypes = response["ShippingServiceTypes"];
   this.ShippingWays = response["ShippingWays"];
   this.ShippingCompanies = response["APIShippingCompanies"];
   this.WeightTypes = response["WeightTypes"];
   this.Directions = response["Directions"];

   this.ShippingDetails.ShippingDirection = this.Directions[0];
   this.ShippingDetails.WeightType = this.WeightTypes[0];
   this.ShippingDetails.ShippingWay = this.ShippingWays[0];
   this.ShippingDetails.ShippingResponsability = this.ShippingResponsabilities[1];
   this.ShippingDetails.ShippingServiceType = this.ShippingServiceTypes[0];
   this.Countries = this.parent.masterData.Countries;
   
   if(this.CurrentShippingAddress != null){
      var country = this.CurrentShippingAddress.Country;
      this.GetCountryShippingOptions(country);
   }
  }

  this.parent.loading = false;
 });
 }

 SelectShippingCompany(s:any){
  this.ShippingCompanies.forEach(element => {
    if (element.ID === s.ID) {
      element.IsSelected = true;
    } else {
      element.IsSelected = false;
    }
  });

  this.ShippingDetails.ShippingCompany = s;
 }

 SelectShippingServiceType(s:any){
  if(s != null){
    this.ShippingDetails.ShippingServiceType = JSON.parse(JSON.stringify(s));
    this.ShippingDetails.ShippingServiceType.IsSelected = true;

    this.ShippingDetails.ShippingCompany.ShippingServiceTypes.forEach(element => {
      element.IsSelected = false;
    });

    this.ShippingDetails.ShippingCompany.ShippingServiceTypes.filter(x => x.ID == this.ShippingDetails.ShippingServiceType.ID)[0].IsSelected = true;
  }
  else{
    this.ShippingDetails.ShippingCompany.ShippingServiceTypes = [];
  }
}

 GetCountryShippingOptions(Country:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Country:Country,
    PartnerID:this.parent.B2BPartner?.ID,
    DirectionID:this.ShippingDetails.ShippingDirection?.ID,
    ShippingCompany:this.ShippingCompanies[0]
  };

 this.parent.loading = true;

 this.managementService.GetCountryShippingOptions(request).subscribe(response => {

   if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
     this.ShippingCompanies = response["ShippingCompanies"];

     if(this.ShippingCompanies.some(x => x.IsSelected == true)){
        this.SelectShippingCompany(this.ShippingCompanies.filter(x => x.IsSelected == true)[0]);
     }
     else if(this.ShippingCompanies != null && this.ShippingCompanies.length > 0){
      this.SelectShippingCompany(this.ShippingCompanies[0]);
     }
   }

   this.parent.loading = false;
   });
}

SendDispatchEmailClientRequest(){

  this.parent.B2BPartner.PartnerAgents = this.PartnerAgents; 

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:this.parent.B2BPartner,
    ShippingDetails:this.ShippingDetails,
    Items:this.ReadyItems,
    ClientMessage:this.ClientMessage,
  };

 this.parent.loading = true;
 this.ShowShipmentRequestPopup = false;

 this.B2BService.SendDispatchEmailClientRequest(request).subscribe(response => {

   if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
    this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
   }
   
   this.parent.loading = false;
   });
}

ShowShipmentRequestPopup:boolean = false;
ClientMessage:string;

}
